import React, { useState } from "react";
import {
  Navbar,
  Container,
  NavDropdown,
  Button,
} from "react-bootstrap";
import styles from "./NavPage.module.css";
import logo from "../../assets/images/svg/logo-navbar-new.svg";
import man from "../../assets/images/svg/account-icon.svg";
import basket from "../../assets/images/svg/basket2.svg";
import en from "../../assets/images/svg/lang-icon.svg";
import saudi from "../../assets/images/svg/saudi.svg";
import oman from "../../assets/images/svg/oman.svg";
import Percent from "../../assets/images/svg/AnimationPercent.svg";
import axios from "axios";
import Cookies from "js-cookie";
import { Link, useLocation } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";

const NavPage = ({ url, translations, language, setLanguage }) => {
  const [selectedCountry, setSelectedCountry] = useState("saudi");
  const [categories, setCategories] = useState([]);
  const [isFetchingCategories, setIsFetchingCategories] = useState(false);
  const { pathname } = useLocation();
  const isProductsPage = pathname.startsWith("/products");

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const selectLanguage = (lang) => {
    handleLanguageChange({ target: { value: lang } });
  };

  const toggleLanguage = () => {
    selectLanguage(language === "en" ? "ar" : "en");
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchCategories = async () => {
    if (isFetchingCategories || categories.length > 0) {
      return;
    }

    setIsFetchingCategories(true);
    try {
      const response = await axios.get(
        `${url}/api/method/geniusapi.www.api.categories`,
      );
      setCategories(response.data.result);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setIsFetchingCategories(false);
    }
  };

  const toggleCountry = () => {
    setSelectedCountry((prevCountry) =>
      prevCountry === "saudi" ? "oman" : "saudi",
    );
  };

  const clearCookies = () => {
    const cookies = document.cookie.split(";");

    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }
  };

  const handleLogout = async () => {
    try {
      const response = await axios.post(url + "/api/method/logout", {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
        },
      });

      if (response.status === 200) {
        // Cookies.remove("token");
        clearCookies();
        window.location.reload();
      }
    } catch (error) {}
  };

  // const handleLogout = async () => {
  //   try {
  //     const response = await fetch(`${url}/api/method/logout`, {
  //       method: 'GET',
  //       credentials: 'include',
  //     });
  //     await response.json();
  //     window.location.href = '/';
  //   } catch (error) {
  //     console.error('Error during logout:', error);
  //   }
  //   clearCookies();
  //   localStorage.clear();

  // };

  const [selectedCategory, setSelectedCategory] = useState({
    category: null,
    label: translations?.result?.AllCategories
      ? translations?.result?.AllCategories
      : "All Categories",
  });

  const [searchText, setSearchText] = useState("");

  const handleSearchClick = () => {
    let customPath = "";

    if (selectedCategory.category !== null) {
      customPath = "?categories=" + selectedCategory.category;
    }

    if (searchText !== "") {
      if (customPath === "") customPath = "?";
      else customPath += "&";

      customPath += "search=" + searchText;
    }

    window.location.href = "/products" + customPath;
  };

  const userLoggedIn = Boolean(Cookies.get("token"));

  return (
    <Navbar
      expand="lg"
      className={`${styles.navbar} ${isProductsPage ? styles.navProducts : ""}`}
    >
      <Container className={styles.nav}>
        <Navbar.Brand>
          <a className={styles.navbarBrand} href="/home">
            <img src={logo} alt="Genius logo" className={styles.brandImage} />
          </a>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="navbarScroll"
          className={styles.navbarToggler}
        />
        <Navbar.Collapse id="navbarScroll">
          <div className={styles.responsiveNav}>
            <div className={styles.upNav}>
              <div className={styles.searching}>
                <NavDropdown
                  title={selectedCategory.label}
                  id="basic-nav-dropdown"
                  onToggle={(isOpen) => {
                    if (isOpen) {
                      fetchCategories();
                    }
                  }}
                >
                  {/* {categories.map((category, index) => (
                    <NavDropdown.Item key={index} href={`#${category.name}`}>
                      {language === "en"
                        ? category.name
                        : category.item_group_name_ar}
                    </NavDropdown.Item>
                  ))} */}
                  <NavDropdown.Item
                    key={0}
                    // href={`/products?categories=${encodeURIComponent(
                    //   category.name
                    // )}`}
                    onClick={() =>
                      setSelectedCategory({
                        category: null,
                        label: translations?.result?.AllCategories
                          ? translations?.result?.AllCategories
                          : "All Categories",
                      })
                    }
                  >
                    {translations?.result?.AllCategories
                      ? translations?.result?.AllCategories
                      : "All Categories"}
                  </NavDropdown.Item>

                  {categories.map((category, index) => (
                    <NavDropdown.Item
                      key={index + 1}
                      // href={`/products?categories=${encodeURIComponent(
                      //   category.name
                      // )}`}
                      onClick={() =>
                        setSelectedCategory({
                          category: category.name,
                          label:
                            language === "en"
                              ? category.name
                              : category.item_group_name_ar,
                        })
                      }
                    >
                      {language === "en"
                        ? category.name
                        : category.item_group_name_ar}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder={
                    translations?.result?.SearchPlaceHolder
                      ? translations?.result?.SearchPlaceHolder
                      : "Search experts, products or brands"
                  }
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <button
                  type="button"
                  className={styles.searchButton}
                  onClick={handleSearchClick}
                  aria-label={
                    translations?.result?.SearchPlaceHolder
                      ? translations?.result?.SearchPlaceHolder
                      : "Search"
                  }
                >
                  <svg
                    className={styles.searchGlass}
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M10.5 3.75a6.75 6.75 0 1 0 4.243 11.999l4.254 4.251 1.06-1.06-4.252-4.254A6.75 6.75 0 0 0 10.5 3.75Zm0 1.5a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
              <div className={styles.settings}>
                <button
                  type="button"
                  className={styles.languageToggle}
                  onClick={toggleLanguage}
                >
                  <img className={styles.langIcon} src={en} alt="Change Language" />
                  <span className={styles.langText}>
                    {language === "en" ? "AR" : "EN"}
                  </span>
                </button>
                <div className={styles.settingsSeperator}></div>
                {!userLoggedIn ? (
                  <a href="/login" className={styles.settingsContent}>
                    <img src={man} alt="Account" />
                  </a>
                ) : (
                  <>
                    <Button
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                      className={styles.navBtn}
                    >
                      <img src={man} alt="Account menu" />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem>
                        <a href="/profile" className={styles.settingsMenuLink}>
                          {" "}
                          {translations?.result?.Profile}
                        </a>
                      </MenuItem>
                      <MenuItem>
                        <button
                          type="button"
                          onClick={handleLogout}
                          className={styles.settingsMenuButton}
                        >
                          {translations?.result?.LogOut}
                        </button>
                      </MenuItem>
                    </Menu>
                  </>
                  // <div className="settings-content">
                  //   <img src={logout} />

                  // </div>
                )}
                <div className={styles.settingsSeperator}></div>
                {/* {Cookies.get("token") !== null &&
                Cookies.get("token") !== "" &&
                Cookies.get("token") != undefined ? ( */}
                <div className={styles.country} onClick={toggleCountry}>
                  <div className={styles.countryContent}>
                    <img
                      src={selectedCountry === "saudi" ? saudi : oman}
                      alt={
                        selectedCountry === "saudi" ? "Saudi Arabia" : "Oman"
                      }
                    />
                    {/* <h1 style={{color:"#000;"}}>{selectedCountry === "saudi" ? "Saudi Arabia" : "Oman"}</h1> */}
                  </div>
                  {/* <div className="country-content">
                    <img src={coins} />
                    {/* <h1>USD</h1> 
                  </div> */}
                </div>
                {userLoggedIn ? (
                  <>
                    <div className={styles.settingsSeperator}></div>
                    <button
                      type="button"
                      className={styles.settingsContentButton}
                      onClick={() => (window.location.href = "/shoppingCart")}
                    >
                      <img
                        src={basket}
                        alt="Shopping cart"
                      />
                      {/* <div className="basket-number">5</div> */}
                    </button>
                  </>
                ) : (
                  <></>
                )}

                {/* // ) : null} */}
              </div>
            </div>
            <div className={styles.downNav}>
              <div className={styles.links}>
                <ul className={`navbar-nav me-auto mb-2 mb-lg-0 ${styles.navList}`}>
                  <li className={`nav-item ${styles.navItem}`}>
                    <a className={`nav-link active ${styles.navLink}`} href="/home">
                      {translations?.result?.home
                        ? translations?.result?.home
                        : "Home"}
                    </a>
                  </li>
                  <li className={`nav-item ${styles.navItem}`}>
                    <a className={`nav-link ${styles.navLink}`} href="/products">
                      {translations?.result?.kids
                        ? translations?.result?.kids
                        : "Kids"}
                    </a>
                  </li>
                  <li className={`nav-item ${styles.navItem}`}>
                    <Link to={"/products"} className={`nav-link ${styles.navLink}`}>
                      {translations?.result?.decor
                        ? translations?.result?.decor
                        : "Décor"}
                    </Link>
                  </li>
                  <li className={`nav-item ${styles.navItem}`}>
                    <Link
                      reloadDocument
                      to={"/products"}
                      className={`nav-link ${styles.navLink}`}
                    >
                      {translations?.result?.products
                        ? translations?.result?.products
                        : "Products"}
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <a className="nav-link" href="/categories">
                    {translations?.result?.categories ? translations?.result?.categories : "Categories"}
                      
                    </a>
                    <div className="hot-status" style={{ top: "-4px" }}>
                      HOT
                    </div>
                  </li> */}
                  <li className={`nav-item ${styles.navItem}`}>
                    <Link
                      to={"/about"}
                      className={`nav-link ${styles.navLink}`}
                      reloadDocument
                    >
                      {translations?.result?.AboutUs
                        ? translations?.result?.AboutUs
                        : "About Us"}
                    </Link>
                  </li>
                  <li className={`nav-item ${styles.navItem}`}>
                    <button type="button" className={styles.navLinkButton}>
                      {translations?.result?.new
                        ? translations?.result?.new
                        : "New"}
                    </button>
                  </li>
                </ul>
                <div className={styles.saleDiv}>
                  <img
                    src={Percent}
                    alt="Percent Icon"
                    className={styles.spin}
                  />
                  <label
                    className={styles.offersText}
                    htmlFor="specialOffers"
                  >
                    {translations?.result?.sale
                      ? translations?.result?.sale
                      : "SALE"}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavPage;
